module.exports = "/_next/static/images/DevOpsKnowImage-67e9de6351e4b9aceff86b6ed3b7b2e4.png.webp";